import type { CreateClientConfig } from '@/openapi/client.gen';

const baseUrl = import.meta.env.VITE_BASE_URL
  ? `${import.meta.env.VITE_BASE_URL}/api`
  : 'http://localhost:3001/api';
export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseUrl,
});
